import { memo } from 'react';
import NapsterSpinner from '../NapsterSpinner';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  className?: string;
}

export const Loader = memo(
  ({ size = 'medium', text, className = '' }: LoaderProps) => {
    return (
      <div className={`flex flex-col items-center justify-center ${className}`}>
        <NapsterSpinner size={size} />
        {text && (
          <p className="text-white/60 text-sm mt-3 font-[NapsterSans]">
            {text}
          </p>
        )}
      </div>
    );
  },
);

Loader.displayName = 'Loader';

export default Loader;
